function isEmpty(object: unknown): boolean {
  if (object && typeof object === 'object') {
    return Object.keys(object).length === 0;
  }

  throw new Error('The "object" argument is not an object');
}

export { isEmpty };
